import { useCallback, useState } from "react";
import { useAppDispatch } from "utils/redux/hooks";
import {
  resetChatbotState,
  sendGeneralMessage,
  setCoachBotPrompt,
} from "app/containers/Chatbot/slice";
import { useNavigate } from "./navigation";

// Starts a fresh Coach Bo chat (Bo's intro first), sends a message asking to
// talk about the given topic, then routes to the Chat with Bo screen.
export const useStartChatAboutTopic = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [pendingTopic, setPendingTopic] = useState<string | null>(null);

  const startChatAboutTopic = useCallback(
    async (topic: string) => {
      setPendingTopic(topic);
      try {
        dispatch(resetChatbotState());
        // Wait for the new thread before navigating, otherwise the Chat with
        // Bo screen can bootstrap its own thread on top of a stale one.
        await dispatch(setCoachBotPrompt(null));
        dispatch(
          sendGeneralMessage({
            message: `Hey Coach Bo, let's talk about “${topic}”`,
          })
        );
        navigate("/user/chatWithBo", { id: "/user/chatWithBo" });
      } finally {
        setPendingTopic(null);
      }
    },
    [dispatch, navigate]
  );

  return { startChatAboutTopic, pendingTopic };
};

// Starts a fresh Coach Bo chat (Bo's intro first), then routes to the Chat
// with Bo screen.
export const useStartNewChat = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return useCallback(async () => {
    dispatch(resetChatbotState());
    // Wait for the new thread before navigating, otherwise the Chat with Bo
    // screen can bootstrap its own thread on top of a stale one.
    await dispatch(setCoachBotPrompt(null));
    navigate("/user/chatWithBo", { id: "/user/chatWithBo" });
  }, [dispatch, navigate]);
};
